



























import { utils } from '@easygenerator/fragment-sdk';
import { Component, Vue } from 'vue-property-decorator';
import CommonForm from './common/CommonForm.vue';

interface AccountDetails {
  accountId: string;
  email: string;
  name: string;
  avatarUrl?: string;
  emailConfirmed: boolean;
}

@Component({
  components: {
    CommonForm
  }
})
export default class ConfirmEmail extends Vue {
  token: string | null = null;

  accountDetails: AccountDetails | null = null;

  errorMessage: string | null = null;

  confirmationEmailSent = false;

  isLoadingCompleted = false;

  async beforeMount() {
    this.token = await this.getAuthToken();
    this.accountDetails = await this.getAccountDetails();
    this.errorMessage = this.getQueryParam('error');

    this.isLoadingCompleted = true;
  }

  get emailSuccessfullyConfirmed(): boolean {
    return this.getQueryParam('success') === 'true';
  }

  get emailIsAlreadyConfirmed(): boolean {
    return this.accountDetails ? this.accountDetails.emailConfirmed : false;
  }

  get showErrorMessage(): boolean {
    return !!this.errorMessage;
  }

  get userAuthorized(): boolean {
    return !!this.token;
  }

  get showConfirmationControls(): boolean {
    return (
      this.userAuthorized &&
      !this.emailSuccessfullyConfirmed &&
      !this.emailIsAlreadyConfirmed &&
      !this.confirmationEmailSent
    );
  }

  async sendConfirmationEmail(): Promise<void> {
    try {
      await utils.HttpWrapper.post('api/v1/confirm-email', {
        bearerToken: this.token!,
        disableRedirects: true
      });

      this.errorMessage = '';
    } catch (err) {
      this.errorMessage = (err as Error).message || (err as string);
    } finally {
      this.confirmationEmailSent = true;
    }
  }

  private async getAuthToken() {
    try {
      const result = await utils.HttpWrapper.post('api/account/token', {
        query: {
          clientId: 'auth'
        },
        disableRedirects: true
      });

      return result.token;
    } catch (e) {
      return null;
    }
  }

  private async getAccountDetails() {
    if (!this.token) {
      return null;
    }

    try {
      return await utils.HttpWrapper.get('api/account/me', {
        bearerToken: this.token,
        disableRedirects: true
      });
    } catch (e) {
      return null;
    }
  }

  private getQueryParam(paramName: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
  }
}
